import {useContext} from "react";
import GlobalContext     from "../../../isp._comun/iu/contexto/GlobalContext";
// import VentanaZona       from "../../../isp.iu.zonas/reductores/ventanas/VentanaZona";
import VentanaQueryZonas from "../../../isp.iu.zonas/reductores/ventanas/VentanaQueryZonas";

// eslint-disable-next-line jsdoc/require-jsdoc
export default function MenuConfiguracion(dispatch) {
    const {
        abrirVentana,
    } = useContext(GlobalContext);
    return [
        {
            label: "Listar Zonas",
            icon: "pi pi-map-marker",
            command: () => {
                            const nuevaVentana = new VentanaQueryZonas();
                            abrirVentana(nuevaVentana);
                            // dispatchPrincipal(new AbrirVentana(nuevaVentana));
                            // dispatch(new AbrirVentanaQueryClientesAFacturar())
                        },
            },
    ];
}
